import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import _ from 'lodash';

const Wrapper = styled.div`
	width: 80%;
	margin: auto;
	h4 {
		text-align: center;
	}
`;

const Payments = styled.div`
	// border: 1px solid red;
	min-height: 8em;

	.upper-level {
		border-bottom: 1px solid gray;
		padding-bottom: 0.6em;
	}

	.bottom-level {
		padding-top: 0.6em;
		padding-left: 2.5em;
		.name {
			font-size: 1.2em;
			wdith: 100%;
		}
		.package-specs {
			display: inline-block;
			width: 100%;
			font-size: 0.8em;
		}
	}

	.title {
		font-size: 1.2em;
		padding-left: 0.2em;
	}

	.amount {
		display: inline-block;
		float: right;
	}
`;

const Links = styled.div`
	margin-top 1rem;
	margin-bottom 1rem;
	text-align: center;
`;

const StyledLink = styled.a`
	color: red;
`;

const getProductDetailLinks = (selectedSubscription, subscriptionsToOrder) => {
	let productLinkDetails = [];
	const linkDetails = [
		{ orderItemCode: 'B2C_PACK_C4_BASIC', anchor: '6-gigan-simmi', displayName: 'Kuuden gigan simmi' },
		{ orderItemCode: 'B2C_PACK_C4_UNLIMITED', anchor: '4g-100', displayName: 'Rajaton 4G 100' },
		{ orderItemCode: 'B2C_PACK_C4_FAST', anchor: '4g-300', displayName: 'Rajaton 4G 300' },
		{ orderItemCode: 'B2C_PACK_5G_300', anchor: '5g-300', displayName: 'Rajaton 5G 300' },
		{ orderItemCode: 'B2C_PACK_5G_600', anchor: '5g-600', displayName: 'Rajaton 5G 600' },
		{ orderItemCode: 'B2C_PACK_5G_1000', anchor: '5g-1000', displayName: 'Rajaton 5G 1000' }
	];

	if (selectedSubscription !== null && selectedSubscription.showInBasket) {
		productLinkDetails.push(linkDetails.filter((detail) => detail.orderItemCode === selectedSubscription.packageSpecs.value.orderItemCode));
	}
	if (subscriptionsToOrder.length > 0) {
		subscriptionsToOrder.forEach((subscription) => productLinkDetails.push(linkDetails.filter((detail) => detail.orderItemCode === subscription.packageSpecs.value.orderItemCode)));
	}
	productLinkDetails = _.uniq(_.flatten(productLinkDetails));
	return (
		<Links>
			{productLinkDetails.map((productLinkDetail, key) => (
				<div key={key}>
					<StyledLink href={`/yleiset-sopimukset-ja-palvelukohtaiset-ehdot-2020#sopimustiivistelma-${productLinkDetail.anchor}`} target="_blank">
						{`Sopimustiivistelmä: ${productLinkDetail.displayName}`}
					</StyledLink>
				</div>
			))}
		</Links>
	);
};

const OrderOverview = (props) => (
	<Wrapper>
		<h4>Tilauksen yhteenveto</h4>
		<Payments>
			<div className={'upper-level'}>
				<span className={'title'}>Kuukausimaksut</span> <span className={'amount'}>{props.monthlyCostTotal} €/KK</span>
			</div>
			<div className={'bottom-level'}>
				{props.selectedSubscription !== null && props.selectedSubscription.showInBasket && (
					<div>
						<span className={'name'}>{props.selectedSubscription.subscriptionName.value ? props.selectedSubscription.subscriptionName.value : 'Nimetön liittymä'}</span>
						<span className={'amount'}>{props.selectedSubscription.packageSpecs.value.eurPerMonth} €/KK</span>
						<span className={'package-specs'}>
							{props.selectedSubscription.packageSpecs.value.displayName},{' '}
							{props.selectedSubscription.packageSpecs.value.dataPackage === 'unlimited' ? 'Rajattomasti dataa' : `${props.selectedSubscription.packageSpecs.value.addToSharedDataGbAmount}Gt dataa`},{' '}
							{props.selectedSubscription.packageSpecs.value.dataSpeedMbs}mbit/s
						</span>
					</div>
				)}
				{props.subscriptionsToOrder.length > 0 &&
					props.subscriptionsToOrder.map((subscription, key) => {
						const packageSpecs = subscription.packageSpecs.value;
						return (
							<div key={key}>
								<span className={'name'}>{subscription.subscriptionName.value}</span>
								<span className={'amount'}>{packageSpecs.eurPerMonth} €/KK</span>
								<span className={'package-specs'}>
									{packageSpecs.displayName}, {packageSpecs.dataPackage === 'unlimited' ? 'Rajattomasti dataa' : `${packageSpecs.addToSharedDataGbAmount} dataa`}, {packageSpecs.dataSpeedMbs}mbit/s
								</span>
							</div>
						);
					})}
			</div>
		</Payments>
		<Payments>
			<div className={'upper-level'}>
				<span className={'title'}>Kertamaksut</span> <span className={'amount'}>5 €</span>
			</div>
			<div className={'bottom-level'}>
				<span>Toimitusmaksu</span>
			</div>
			{getProductDetailLinks(props.selectedSubscription, props.subscriptionsToOrder)}
		</Payments>
	</Wrapper>
);

OrderOverview.propTypes = {
	selectedSubscription: PropTypes.object,
	subscriptionsToOrder: PropTypes.array,
	monthlyCostTotal: PropTypes.number
};

export default OrderOverview;
